import React from 'react';
import PropTypes from 'prop-types';
import { agentProductionTerms as apt, searchTerms as st } from '../../../constants';
import { terms as suggATerms } from '../../constants/suggestedAgents';

const Footer = ({ timePeriodTitle, propertyTypeNames=[], mlsName, productionTitle, area, detailedPropertyType=undefined, hasEllipsis=false }) => {
    const allResidential = `${st.allResidential}: (${propertyTypeNames.join(", ")})`;

    return (
        <div>
            <div className='footer-wrapper'>
                <span className='d-inline helix-text-gray-500'>
                    <span className='helix-body--strong'>{st.mls}:</span> {`${mlsName} `}
                    <span className='helix-body--strong ml-1'>{apt.area}:{' '}</span> <span className={`${hasEllipsis ? 'footer-text-area' : ''}`}>{`${area ?? st.allMls} `}</span>
                    <span className='helix-body--strong ml-1'>{st.timeFrame}:{' '}</span>{`${timePeriodTitle} `}
                    <span className='helix-body--strong ml-1'>{st.propertyTypesSA}:{' '}</span><span className={`${hasEllipsis ? 'footer-text-area' : ''}`}>{detailedPropertyType ?? allResidential}</span>
                    <span className='helix-body--strong ml-1'>{productionTitle && `${suggATerms.production}: `} </span> {productionTitle}
                </span>
            </div>
        </div>
    );
};

export default Footer;

Footer.propTypes = {
    productionTitle: PropTypes.string,
    mlsName: PropTypes.string,
    propertyTypeNames: PropTypes.array,
    timePeriodTitle: PropTypes.string,
    area: PropTypes.string,
    detailedPropertyType: PropTypes.string,
    hasEllipsis: PropTypes.bool,
};
